import React from "react";
import { NavLink } from "react-router-dom";
import {
  RiCalendarLine,
  RiHealthBookLine,
  RiQuestionAnswerLine,
  RiSurveyLine,
} from "react-icons/ri";
import logo from "../assets/logo_endopoints.svg";

const AppSelector = () => {
  return (
    <div className="bg-gradient-to-b from-[#D1F1FF] to-[#B49DCB] flex flex-col items-center py-24 px-16 gap-4">
      <img
        className="mb-16"
        src="https://ascend.cr/wp-content/uploads/2023/05/congreso-endocrionologia-2023_1.webp"
        alt="logo congreso"
      />
      <div className="flex gap-2">
        <div className="bg-white p-8 border rounded-md h-48 w-48 flex items-center justify-center">
          <NavLink to="/endopoints-login">
            <img className="w-full" src={logo} alt="logo endopoints" />
          </NavLink>
        </div>
        <div className="bg-white p-16 border rounded-md h-48 w-48 flex text-center items-center justify-center">
          <NavLink
            className="flex flex-col items-center justify-center"
            to="/speaker-questions"
          >
            <RiQuestionAnswerLine className="text-4xl" />
            <p className="text-2xl font-bold">Preguntas al ponente</p>
          </NavLink>
        </div>
      </div>
      <div className="flex gap-2">
        <div className="bg-white p-16 border rounded-md h-48 w-48 flex items-center justify-center">
          <a
            href="https://polpo-assets.s3.amazonaws.com/production/Congreso+Endocrino/Pdf/ProgramaCongresoFinal.pdf"
            className="flex flex-col items-center justify-center"
          >
            <RiCalendarLine className="text-4xl" />
            <p className="text-2xl font-bold">Agenda</p>
          </a>
        </div>
        <div className="bg-white p-16 border rounded-md h-48 w-48 flex items-center justify-center">
          <NavLink
            className="flex flex-col items-center justify-center"
            to="/clinical-cases"
          >
            <RiHealthBookLine className="text-4xl" />
            <p className="text-2xl font-bold text-center">Casos Clínicos</p>
          </NavLink>
        </div>
      </div>
      <div className="flex gap-2">
        <div className="bg-white p-16 border rounded-md h-48 w-48 flex items-center justify-center">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdYk7QSKeNbKwjBE4YEhPGm40S8-tZ5Y391OPCMb8z73VNBqw/viewform?usp=sf_link"
            className="flex flex-col items-center justify-center"
          >
            <RiSurveyLine className="text-4xl" />
            <p className="text-2xl font-bold">Encuesta de Satisfacción</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppSelector;
